const model = {
    compositeProduct: null,
    loading: false,
    error: null,
};

export default model;